// @flow

import appsLink from './appsLink';
import blogLink from './blogLink';
import exploreLink from './exploreLink';

// Account action paths
export const signupPath = '/sign-up/';
export const loginPath = '/app/login';

// Utility constants

export const skipLinkHref = '#mainContent';

// Navigation Links

// These links have submenus.
// Exporting here would allow clients to import links from a single source
export { appsLink, exploreLink, blogLink };

export const dashboardLink = {
  href: '/app/dashboard',
  icon: 'navDashboard',
  text: 'Dashboard',
};

export const zapsLink = {
  href: '/app/zaps',
  icon: 'miscBolt',
  text: 'Zaps',
};

export const myAppsLink = {
  href: '/app/connections',
  icon: 'navApps',
  text: 'My Apps',
};

export const historyLink = {
  href: '/app/history',
  icon: 'miscClock',
  text: 'Task History',
};

export const helpLink = {
  href: '/help',
  icon: 'navHelp',
  isExternal: true,
  text: 'Get Help',
};

export const usageLink = {
  href: '/app/settings/billing',
  icon: 'miscWallet',
  text: 'Usage',
};

export const pricingLink = {
  href: '/pricing',
  icon: 'miscWallet',
  text: 'Pricing',
};

export const moveZapsLink = {
  href: '/app/move-zaps/',
  icon: 'arrowBigRight',
  text: 'Move Zaps',
};

export const settingsLink = {
  href: '/app/settings/profile',
  icon: 'navCog',
  text: 'Settings',
};

export const logOutLink = {
  href: '/logout',
  icon: 'arrowExit',
  text: 'Log Out',
};

// Sidebar Links for a logged in user
export const UniversalSidebarLinks = [
  dashboardLink,
  zapsLink,
  myAppsLink,
  historyLink,
  exploreLink,
  helpLink,
];

// Topbar links
export const UniversalTopbarLinks = [
  appsLink,
  exploreLink,
  blogLink,
  pricingLink,
];

// Account Menu links
export const AccountsMenuLinks = [settingsLink, logOutLink];
